/**
 * Adapters between AddictionForm's Addiction v2 body shape (camelCase,
 * sent to api-addiction-v2-service today) and the transcript's
 * captured-item payload shape (snake_case, matches what the Python
 * agent emits and what Go's SaveSection fan-out reads on Save & next).
 *
 * Same pattern as complaintBodyAdapters / diagnosisBodyAdapters /
 * medicineBodyAdapters / hospitalisationBodyAdapters /
 * labInvestigationBodyAdapters / allergyBodyAdapters /
 * familyHistoryBodyAdapters.
 *
 *   Addiction v2 body        → captured "add" payload
 *   {key, status, startedWhen:{y,m,d}, totalInterval:{y,m,d},
 *    frequency, description, statusUpdate}
 *      →
 *   {key, status, started_years, started_months, started_days,
 *    total_years, total_months, total_days, frequency, description,
 *    status_update, value}
 *
 * `value` is the display string the review table + captured-item cards
 * render as the "title" of the row.
 */

const titleCase = (s) => s.replace(/\b\w/g, (c) => c.toUpperCase());
const toIsoDate = (iso) => (typeof iso === "string" && iso ? iso.slice(0, 10) : "");

/**
 * Addiction v2 body → captured "add" payload.
 */
export function bodyToCapturedAdd(body) {
  const sw = body.startedWhen || {};
  const ti = body.totalInterval || {};
  const key = body.key || "";
  const status = body.status || "never";
  return {
    key,
    status,
    frequency:      body.frequency || "",
    description:    body.description || "",
    started_years:  Number(sw.years)  || 0,
    started_months: Number(sw.months) || 0,
    started_days:   Number(sw.days)   || 0,
    total_years:    Number(ti.years)  || 0,
    total_months:   Number(ti.months) || 0,
    total_days:     Number(ti.days)   || 0,
    status_update:  toIsoDate(body.statusUpdate),
    value:          key ? `${titleCase(key)} — ${status}` : status,
  };
}

/**
 * Stub — Wave B first-cut doesn't route Addiction updates via AI.
 * Symmetric with the other section adapters.
 */
export function bodyToCapturedUpdate(body /* , context */) {
  return bodyToCapturedAdd(body);
}
